import { get } from 'lodash';

const showCoverageForRequester = state =>
  !state.user.model.isRequester || get(state.agency, 'selectedAgency.insuranceInformationShow', true);

export const showCoverageInformation = state =>
  window.ambulnzConfig.userSettings.isBillingEnabled && showCoverageForRequester(state);
